import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { registerSW } from 'virtual:pwa-register';
import { AuthProvider } from './lib/auth';
import { App } from './App';
import './styles/fonts.css';
import './styles/app.css';
import './styles/system.css';

// Auto-aggiornamento: la PWA controlla una nuova versione ogni 60s e si aggiorna DA SOLA
// (registerType 'autoUpdate' + skipWaiting/clientsClaim nel SW) → niente più riapertura manuale.
registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, r) {
    if (r) setInterval(() => { void r.update(); }, 60_000);
  },
});

// Tap su una notifica con l'app gia' aperta: soft-nav (niente reload → non perde WS live / stato in memoria).
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (e: MessageEvent) => {
    const d = e.data as { type?: string; url?: string } | null;
    if (d?.type === 'navigate' && typeof d.url === 'string' && location.pathname !== d.url) {
      history.pushState(null, '', d.url);
      dispatchEvent(new PopStateEvent('popstate'));
    }
  });
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
